<template>
  <BaseNotification v-if="isShowEduYearlyNotification">
    <p class="mr-4">
      Annual billing is now available for your Edu plan!
      Starting from just <strong>$1.95/month</strong>.
      Use this reference code for a further 25% off: “<strong>GIVEME1YEAR</strong>”
      (expires {{ couponExpiryDate }}).
    </p>
    <aha-button
      variant="warning"
      class="md:ml-auto flex-grow-0 flex-shrink-0 h-6 my-2 sm:-mt-0.5 sm:mb-0"
      @click="upgrade()"
    >
      Learn more…
    </aha-button>
  </BaseNotification>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import Utils from '@/util'
import BaseNotification from './BaseNotification.vue'

export default {
  components: {
    BaseNotification,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      isShowEduYearlyNotification: () => {
        return false
      },
      currentPlan: (state) => state.plan,
    }),
    couponExpiryDate() {
      return moment().locale('en').endOf('month').format('DD MMMM')
    },
  },
  methods: {
    upgrade() {
      if (this.currentPlan.group !== 'edu') return
      Utils.gaTrackEvent(Utils.getGACategories(this.$route.name), 'Edu Yearly Notification bar > Click Learn more', this.currentPlan.type)
      this.$router.push({
        name: 'UserPlan',
        query: {
          planGroup: 'educational',
        },
      })
    },
  },
}
</script>

<style>

</style>
